/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'csrf-policy';

export const csrfPolicyModalBreadcrumbTitle = `${prefix}.csrfPolicyModalBreadcrumbTitle`;

export const ENGLISH = {
    [csrfPolicyModalBreadcrumbTitle]: 'CSRF Policy',
};
